import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgAstuteClassFleetSubmarine = function ({
  size = 16,
  ...props
}: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 41"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M4.243 17.773c.635-.514 1.66-1.082 3.372-1.647l1.1-.34c3.258-.978 11.727-3.418 17.026-4.326a.495.495 0 0 1 .476-.348l.148-.002.002-2.88c0-.282.229-1.122.511-1.122h.36c.281 0 .51.84.51 1.123l-.002 2.88 27.411.002c2.03 0 3.843-.642 4.503-1.832l.116-.246 1.318-8.015.066-.166.048-.096A1.44 1.44 0 0 1 62.33.016L62.587 0h25.615c1.668 0 3.61.092 5.037.854a3.8 3.8 0 0 1 1.189.952l.636.82c1.347 1.775 3.993 5.405 5.796 7.89l3.842-.275c4.724-.321 10.297-.616 16.752-.654l1.397-.004h35.909c3.473 0 11.369 2.923 18.892 6.086l1.45.614.507-7.393.054-.066c.215-.205.898-.378 3.297-.448l1.298-.033.275-.002c1.159 0 3.06.318 3.876.498l.194.046-.083.004h.065v10.996l-.505.378 3.56 1.653v-2.262l5.936 1.39v3.185c1.308.256 2.424.716 2.424 1.243 0 .487-.951.916-2.126 1.181l-.298.063v3.186l-5.936 1.39v-2.247l-1.128.522q-.597.273-1.255.567l-.672.298v8.95l-.17.323-.605.12c-.942.174-2.348.377-3.276.377l-.266-.001-1.374-.027c-2.39-.07-3.026-.246-3.239-.453l-.054-.066-.012-.306-.36-5.222c-3.93 1.347-7.923 2.397-11.075 2.53l-.662.015H37.35c-4.41 0-31.05-5.399-32.76-5.67-.745-.117-1.211-.28-1.547-.489-.349-.218-.554-.487-.756-.817l-.154-.26C1.67 28.636 0 26.504 0 25.424c0-.868.41-1.661.702-2.117l.299-.42 2.408-4.168c.129-.224.314-.474.6-.741z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgAstuteClassFleetSubmarine
